import axios from 'axios';
import store, { history } from '../../store';
import getTeams from '../GetTeams';

export const ACCOUNT_ACTIVATED = 'ACCOUNT_ACTIVATED';

const activateAccount = (teamId, productIds, newProductName = null) => (
  dispatch => (
    axios.post(`/api/teams/${teamId}/activate`, {
      team_id: teamId,
      suggested_products: productIds,
      new_product_name: newProductName,
    })
      .then(() => {
        dispatch({
          type: ACCOUNT_ACTIVATED,
          teamId,
        });

        window.location = `/products`;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location = '/login';
        }
      })
  )
);

export default activateAccount;
